<template>
    <div class="screen">
        <Dialog v-model:visible="visible" modal :closable="false" class="alrt">
            <div class="card flex justify-center">
                <ProgressSpinner style="width: 50px; height: 50px; display: block; margin: auto;" strokeWidth="8"
                    fill="transparent" animationDuration=".5s" aria-label="Custom ProgressSpinner" />
            </div>
        </Dialog>
        <div class="fondo"></div>
        <div class="formulario">
            <img src="../assets/logo.jpg" alt="Logotipo" class="logo">

            <!-- Email con Icono -->
            <div class="input-group">
                <IconField>
                    <InputIcon class="pi pi-user" />
                    <InputText v-model="email" placeholder="Email" class="input-prime" @keyup="EnterKey()"/>
                </IconField>
            </div>

            <!-- Password con Icono -->
            <div class="input-group">
                <IconField>
                    <InputIcon class="pi pi-lock" />
                    <InputText v-model="password" type="password" placeholder="Password" class="input-prime" @keyup="EnterKey()"/>
                </IconField>
            </div>
            <div class="input-group">
                <p class="link">¿Olvidaste tu contraseña?</p>
            </div>
            <button class="btn-login" @click="login">Login</button>
            <p class="text-bottom"> Version: BETA 0.1</p>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import api from '../plugins/axios';
import { InputText,InputIcon,IconField, Dialog, ProgressSpinner } from 'primevue';
import { useToast } from 'vue-toastification';

const toast = useToast();
const email = ref('');
const password = ref('');
const router = useRouter();
const visible = ref(false);

const login = async () => {
    visible.value = true;
    try {
        const res = await api.post('/access', { email: email.value, password: password.value });
        console.log(res.data)
        if (res.data.status === "success") {
            localStorage.setItem('token', res.data.access_token);
            toast.success('Bienvenido');
            await data();
        }
    } catch (err) {
        visible.value = false;
        toast.error('Credenciales incorrectas');
    }
};

const data = async()=>{
    try{
        const res = await api.get("/me");
        console.log(res.data)
        localStorage.setItem("id", res.data.id);
        localStorage.setItem("nombre", res.data.name);
        localStorage.setItem("role_id", res.data.role_id)
        setTimeout(() => {
                if(res.data.role_id === 3)
                {
                    visible.value = false;
                    router.push('/Operador');
                }
                else
                {
                    visible.value = false;
                    router.push('/Inicio');
                }
        }, 1000);
    }
    catch(err)
    {
        console.error(err);
    }
}

const EnterKey = () => {
    let e = event || window.event;
    if (e.key === 'Enter') {
        login();
    }
}
</script>

<style scoped>
.alrt {
    width: 20%;
}

.screen {
    width: 100%;
    height: 100vh;
    display: flex;
    background-color: #F7F7F7;
}

.fondo {
    background-image: url("../assets/ingenieria.jpg");
    background-attachment: fixed;
    width: 30%;
    height: 100%;
}

.link {
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
}

.link:hover {
    color: rgb(0, 92, 192);

}

.formulario {
    width: 20%;
    margin-left: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.logo {
    width: 110px;
    height: 100px;
    margin-bottom: 30px;
}

.input-group {
    width: 100%;
    margin-bottom: 20px;
}

/* Ajuste específico de PrimeVue IconField */
.input-prime {
    width: 100%;
    height: 40px;
    padding-left: 1rem;
    /* espacio para el icono */
    box-sizing: border-box;
    border-radius: 5px;
    font-size: 14px;
}

.btn-login {
    width: 100%;
    padding: 10px;
    background-color: #10B981;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 16px;
    border-radius: 4px;
}

.btn-login:hover {
    transition: all .45s;
    background-color: #068e60;
}

.text-bottom {
    position: absolute;
    font-size: 12px;
    font-weight: bold;
    bottom: 0;
    right: 12px;
}

.p-icon-field>.p-input-icon {
    top: 33% !important;
}

@media (max-width:1024px) {
    .formulario {
        width: 50%;
        margin-left: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .alrt {
        width: 30%;
    }
}

@media (max-width:745px) {
    .formulario {
        width: 70%;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .fondo {
        display: none;
    }

    .alrt {
        width: 60%;
    }
}
</style>
